import useGetMyBusinessHours from '@/api/queries/me/useGetMyBusinessHours';
import { DateInput as PlDateInput } from '@payaca/ambrosia';

import { ComponentProps, FC } from 'react';

export const DateInput: FC<ComponentProps<typeof PlDateInput>> = (props) => {
  const { data } = useGetMyBusinessHours();

  return <PlDateInput {...props} businessHours={data} />;
};
